"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubCrustMeasurements = void 0;
var Tags_1 = require("./../Tags");
var Card_1 = require("../Card");
var CardType_1 = require("./../CardType");
var CardName_1 = require("../../CardName");
var CardRequirements_1 = require("../CardRequirements");
var CardRenderer_1 = require("../render/CardRenderer");
var SubCrustMeasurements = (function (_super) {
    __extends(SubCrustMeasurements, _super);
    function SubCrustMeasurements() {
        return _super.call(this, {
            cardType: CardType_1.CardType.ACTIVE,
            name: CardName_1.CardName.SUB_CRUST_MEASUREMENTS,
            tags: [Tags_1.Tags.SCIENCE, Tags_1.Tags.BUILDING, Tags_1.Tags.EARTH],
            cost: 20,
            requirements: CardRequirements_1.CardRequirements.builder(function (b) { return b.tag(Tags_1.Tags.SCIENCE, 2); }),
            metadata: {
                cardNumber: 'X29',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.action('Draw a card.', function (eb) {
                        eb.empty().startAction.cards(1);
                    });
                }),
                description: 'Requires 2 science tags.',
                victoryPoints: 2,
            },
        }) || this;
    }
    SubCrustMeasurements.prototype.play = function () {
        return undefined;
    };
    SubCrustMeasurements.prototype.canAct = function () {
        return true;
    };
    SubCrustMeasurements.prototype.getVictoryPoints = function () {
        return 2;
    };
    SubCrustMeasurements.prototype.action = function (player) {
        player.drawCard();
        return undefined;
    };
    return SubCrustMeasurements;
}(Card_1.Card));
exports.SubCrustMeasurements = SubCrustMeasurements;
//# sourceMappingURL=SubCrustMeasurements.js.map